<template>
    <div class="log-order-detail-dialog-delete">
        <el-dialog
            :visible.sync="dialogDelete.isDialog"
            width="30%"
            custom-class="loadingDialogDelete"
            :show-close="false"
            :close-on-click-modal="false"
            center
            >
            <span slot="title" style="font-size: 20px; padding-top: 20px;">
                คุณแน่ใจหรือไม่ว่าจะลบ Order นี้ ?
            </span>
            <span slot="footer">
                <el-button type="primary" class="dialog-delete-btn-cancel" @click="dialogDelete.isDialog = false">ยกเลิก</el-button>
                <el-button type="danger" class="dialog-delete-btn-confirm" @click="onConfirmDelete()">ลบเลย</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'DialogComplete',
    props: {
        dialogDelete: {
            type: Object,
            default: () => {
                return {
                    isDialog: false,
                    data: {
                        orderNumber: null,
                        orderId: null
                    }
                }
            }
        }
    },
    data () {
        return {
        }
    },
    methods: {
        async onConfirmDelete () {
            let loadingDeleteOrder = this.$loading({
                target: '.loadingDialogDelete',
                text: 'กำลังลบ...'
            })

            let param = {
                orderNumber: this.dialogDelete.data.orderNumber,
                adminEmail: this.$store.get('user/objUser').email
            }
            try {
                let res = await fgApi.order.deleteOrderLogOrder(param)
                if (res.success) {
                    this.$notify({
                        title: 'Success',
                        message: 'Delete successful',
                        type: 'success'
                    })
                    this.dialogDelete.isDialog = false
                    this.$emit('onDeleteSuccess', this.dialogDelete.data.orderId)
                } else {
                    this.$notify.error({
                        title: 'Error',
                        message: res.message
                    })
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            loadingDeleteOrder.close()
        }
    }
}
</script>

<style lang="scss">
.log-order-detail-dialog-delete {
    .el-dialog {
        height: 220px;
        .el-dialog__header {
            padding-top: 60px;
        }
        .el-dialog__body {
            padding: 10px 15px 20px;
        }
    }

    .dialog-delete-btn-confirm {
        background-color: #de0000;
        color: white;
        width: 120px;
    }

    .dialog-delete-btn-cancel {
        background-color: teal;
        color: white;
        width: 120px;
    }

    .el-button--primary:hover {
        background-color: #26a69a;
        border-color: #26a69a;
    }
}
</style>
